define("shared/components/shared/mobile/drawer/layout", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@closeModal}} @focusTrap={{true}} ...attributes as |modal|>
    <modal.card @portrait={{true}} class="u--p__b__0">
      <header class="o--modalHeader u--p__b__sm" data-test-id="mobile-drawer-title">
        <h2 class="u--text--lg u--m__t__0 u--m__b__0">{{@title}}</h2>
      </header>
      <div class="o--modalBody u--p__0">
        <div class="u--p__lr__lg">
          {{yield to="body"}}
        </div>
        <div class="tOB--mobDrawer__footer u--p__t__sm u--p__lr__lg u--p__b__lg">
          {{yield to="footer"}}
        </div>
      </div>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "H+/IOqE4",
    "block": "[[[8,[39,0],[[17,1]],[[\"@close\",\"@focusTrap\"],[[30,2],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,3,[\"card\"]],[[24,0,\"u--p__b__0\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[10,\"header\"],[14,0,\"o--modalHeader u--p__b__sm\"],[14,\"data-test-id\",\"mobile-drawer-title\"],[12],[1,\"\\n      \"],[10,\"h2\"],[14,0,\"u--text--lg u--m__t__0 u--m__b__0\"],[12],[1,[30,4]],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--modalBody u--p__0\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--p__lr__lg\"],[12],[1,\"\\n        \"],[18,5,null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tOB--mobDrawer__footer u--p__t__sm u--p__lr__lg u--p__b__lg\"],[12],[1,\"\\n        \"],[18,6,null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[3]]]]]],[\"&attrs\",\"@closeModal\",\"modal\",\"@title\",\"&body\",\"&footer\"],false,[\"shared/modal\",\"yield\"]]",
    "moduleName": "shared/components/shared/mobile/drawer/layout.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});